import { GENDER_IDENTITY } from '../questionnaire/Constants';

export const TWIN_TYPES = Object.freeze({
  identical: 'identical',
  nonIdentical: 'non-identical',
  unknown: 'unknown'
});

export const TWIN_IDENTIFIERS = Object.freeze({
  mztwin: 'mztwin',
  dztwin: 'dztwin',
  cztwin: 'cztwin'
});

const DECEASED_ALIASES = new Set(['false', 'no', '0']);

export const resolveVitalStatus = ({ isAlive, dod } = {}) => {
  if (dod) return 'false';
  if (isAlive === null || isAlive === undefined || isAlive === '')
    return 'true';
  return DECEASED_ALIASES.has(String(isAlive).trim().toLowerCase())
    ? 'false'
    : 'true';
};

// map of relations used in the pedigree
export const RELATIONS = {
  children: 'children',
  siblings: 'siblings',
  halfSiblings: 'halfSiblings',
  partner: 'spouse',
  parent: 'parent',
  mothersParent: 'mothersParent',
  fathersParent: 'fathersParent',
  parentsSibling: 'parentsSibling',
  otherAffected: 'otherAffected'
};

// map of all relations - coming from fhq
export const relationMap = {
  self: RELATIONS.siblings,
  mother: RELATIONS.parent,
  father: RELATIONS.parent,
  son: RELATIONS.children,
  daughter: RELATIONS.children,
  fullSister: RELATIONS.siblings,
  fullBrother: RELATIONS.siblings,
  halfSister: RELATIONS.halfSiblings,
  halfBrother: RELATIONS.halfSiblings,
  spouse: RELATIONS.partner,
  mothersMother: RELATIONS.mothersParent,
  mothersFather: RELATIONS.mothersParent,
  fathersMother: RELATIONS.fathersParent,
  fathersFather: RELATIONS.fathersParent,
  mothersBrother: RELATIONS.parentsSibling,
  mothersSister: RELATIONS.parentsSibling,
  fathersBrother: RELATIONS.parentsSibling,
  fathersSister: RELATIONS.parentsSibling,
  otherAffected: RELATIONS.otherAffected
};

// offset used for the editor's position
export const offset = 500;
export const boxSize = { w: '100%', h: 950 };

// NOTE: dead code — no current consumer imports this (its only callers lived in
// the legacy src/components/pedigree/ tree, now removed). Safe to delete in a
// follow-up. If it is ever revived, mint the uid via mintObjectIdHex
// (pedigree-tool/pedigree/saveReconciliation.js) so members are born with a
// stable ObjectId-shaped identity.
export const generateNewUser = (
  gender,
  user_id,
  relation = 'otherAffected'
) => {
  const user = {
    firstName: null,
    pid: crypto.randomUUID(),
    relationship: relation,
    diagnoses: [],
    gender: gender,
    genderIdentity: GENDER_IDENTITY[gender] ?? GENDER_IDENTITY.unknown,
    user_id: user_id
  };

  return user;
};

export const relationship = {
  mother: 'mother',
  father: 'father',
  son: 'son',
  daughter: 'daughter',
  fullSister: 'fullSister',
  fullBrother: 'fullBrother',
  halfSister: 'halfSister',
  halfBrother: 'halfBrother',
  spouse: 'spouse',
  mothersMother: 'mothersMother',
  mothersFather: 'mothersFather',
  fathersMother: 'fathersMother',
  fathersFather: 'fathersFather',
  mothersBrother: 'mothersBrother',
  mothersSister: 'mothersSister',
  fathersBrother: 'fathersBrother',
  fathersSister: 'fathersSister',
  otherAffected: 'otherAffected'
};

export const DEFAULT_CANVAS_PREFERENCES = {
  symbol_size: 155,
  font_size: 70,
  horizontal_spacing: 100,
  vertical_spacing: 100,
  enable_grid: false,
  // Default ON: node spacing (H×V) is derived from label density/length instead of
  // the manual percentages, so charts space themselves to fit their labels out of
  // the box. Users can turn it off in Pedigree Settings to set H×V manually.
  auto_spacing: true
};
